export default "__VITE_ASSET__C5D1LPB7__"